// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useOperatorParty } from '../hooks/queries/utility-operator/useOperatorParty';

export enum SigningMode {
  LOCAL = 'LOCAL',
  DFNS = 'DFNS',
}

export interface ModuleState {
  activeParty: string;
  activeSigningMode: SigningMode;
}

export const ModuleContext = React.createContext<ModuleState | undefined>(undefined);

export const useModule = () => {
  const context = React.useContext(ModuleContext);
  if (!context) {
    throw new Error('useModule must be used within a ModuleProvider');
  }
  return context;
};

export const useModuleSigningMode = () => {
  const { activeSigningMode } = useModule();
  return activeSigningMode;
};

export const useModuleParty = () => {
  const { activeParty } = useModule();
  return activeParty;
};

export const useIsOperator = () => {
  const operator = useOperatorParty()?.data;
  const party = useModuleParty();

  return operator === party;
};
